import { Link } from 'react-router-dom';
import styles from './Plans.module.css';

function Plans() {
    return (
        <section className={styles.plans}>
            <div className={styles.container}>

                <div className={styles.sectionHeader}>
                    <h2>Conheça nossos planos</h2>
                    <p>Comece com 7 dias grátis e escolha o plano que melhor atende às necessidades do seu criatório.</p>
                </div>

                <div className={styles.planGrid}>

                    {/* BÁSICO */}
                    <div className={styles.plan}>
                        <div className={styles.planHeader}>
                            <h3>Básico</h3>

                            <div className={styles.price}>
                                <strong>R$ 11,90</strong>
                                <span>/ mês</span>
                            </div>
                        </div>

                        <p className={styles.planDescription}>Ideal para quem está começando a organizarseu criatório.</p>

                        <ul>
                            <li>✓ Até 10 gaiolas</li>
                            <li>✓ Até 100 aves</li>
                            <li>✓ Controle de reprodução</li>
                            <li>✓ Cadastro de aves</li>
                            <li>✓ Controle do plantel</li>
                        </ul>

                        <Link to="/register" className={styles.planButton}>Começar teste grátis</Link>

                    </div>


                    {/* INTERMEDIÁRIO */}
                    <div className={`${styles.plan} ${styles.planFeatured}`}>
                        <div className={styles.recommended}>Mais escolhido</div>

                        <div className={styles.planHeader}>
                            <h3>Intermediário</h3>

                            <div className={styles.price}>
                                <strong>R$ 14,99</strong>
                                <span>/ mês</span>
                            </div>
                        </div>

                        <p className={styles.planDescription}>Para criatórios que precisam de mais espaço para crescer.</p>

                        <ul>
                            <li>✓ Até 25 gaiolas</li>
                            <li>✓ Até 200 aves</li>
                            <li>✓ Controle de reprodução</li>
                            <li>✓ Cadastro de aves</li>
                            <li>✓ Controle do plantel</li>
                        </ul>

                        <Link to="/register" className={styles.planButton}>Começar teste grátis</Link>
                    </div>


                    {/* COMPLETO */}
                    <div className={styles.plan}>
                        <div className={styles.planHeader}>
                            <h3>Completo</h3>

                            <div className={styles.price}>
                                <strong>R$ 19,99</strong>
                                <span>/ mês</span>
                            </div>
                        </div>

                        <p className={styles.planDescription}>Para criatórios que precisam de liberdade para crescer sem limites.</p>

                        <ul>
                            <li>✓ Gaiolas ilimitadas</li>
                            <li>✓ Aves ilimitadas</li>
                            <li>✓ Controle de reprodução</li>
                            <li>✓ Cadastro de aves</li>
                            <li>✓ Controle do plantel</li>
                        </ul>
                        
                        <Link to="/register" className={styles.planButton}>Começar teste grátis</Link>
                    </div>

                </div>


                <div className={styles.plansFooter}>
                    <span>🎁</span>
                    <strong>Teste grátis por 7 dias.</strong>
                    <span>Comece agora e escolha seu plano depois.</span>
                </div>

            </div>
        </section>
    );
}

export default Plans;